const dateDDMMYYYYRegex = /^(\d{1,2})(\.?)(\d{0,2})(\.?)(\d{0,4})/;

export function formatToDDMMYYYY(date: string): string {
  return formatInputDate(date, dateDDMMYYYYRegex);
}

function formatInputDate(
  input: string,
  regex: RegExp,
  separator = ".",
): string {
  if (regex.test(input)) {
    const matches = input.match(regex);
    if (matches) {
      let formatted = "";
      matches.forEach((value, index) => {
        if (index > 0 && value) {
          if (isDoubleDigitAndNoSeparatorAfter(matches, value, index)) {
            formatted += `${value}${separator}`;
          } else {
            formatted += value;
          }
        }
      });
      return formatted;
    }
  }
  return "";
}

function isDoubleDigitAndNoSeparatorAfter(
  matches: RegExpMatchArray,
  value: string,
  index: number,
): boolean {
  return (
    /\d{2}/.test(value) &&
    matches.length > index + 2 &&
    !matches[index + 1] &&
    /\d/.test(matches[index + 2])
  );
}
